import React, { Component } from 'react';
import { Link } from "react-router-dom";

import { Button } from 'antd';
import { Layout } from 'antd';
import { Menu } from 'antd'
import { Row, Col } from 'antd';
import { Anchor } from 'antd'

import './Main.less';
import './Content.less'

const { Header, Footer, Sider, Content } = Layout;

class Main extends Component {
    componentDidMount() {
        document.title = "Summer School 2019"
    }

    render() {
        return (
            <Layout>
                <Header id='header' style={{ position: 'fixed', zIndex: 1, width: '100%' }}>
                    <Row type='flex'>
                        <Col>
                            <Link to='/'>
                                <img
                                    alt="logo"
                                    src="logo-nmbu.png"
                                    style={{ maxHeight: '50px' }}
                                />
                            </Link>
                        </Col>
                        <Col style={{ marginLeft: 'auto' }}>
                            <Menu
                                id='nav'
                                theme="light"
                                mode="horizontal"
                            >
                                <Menu.Item key="1">
                                    <Link to='/2018' style={{ fontWeight: 700 }}>2018</Link>
                                </Menu.Item>
                                <Menu.Item key="2">
                                    <a href="#about">About</a>
                                </Menu.Item>
                                <Menu.Item key="3">
                                    <a href='#materials'>Materials</a>
                                </Menu.Item>
                                <Menu.Item key="4">
                                    <a href='#program'>Program</a>
                                </Menu.Item>
                                <Menu.Item key="5">
                                    <a href='#venue'>Venue</a>
                                </Menu.Item>
                                <Menu.Item key="6">
                                    <a href='#contact'>Contact</a>
                                </Menu.Item>
                            </Menu>
                        </Col>
                    </Row>
                </Header>
                <Content style={{marginTop: 64, backgroundColor: 'white'}}>
                    <section id='hero-area' className='main-container'>
                        <Row gutter={64}>
                            <Col sm={12} xs={24}>
                                <h1>Interdisciplinary summer school<br />on mining of biological data</h1>
                                <p>August 2019, Minsk, Belarus</p>
                            </Col>
                            <Col sm={12} xs={24}>
                                {/* <iframe title='Summer School Video' width="560" height="315" src="https://www.youtube.com/embed/qE8KGDy0Tx8" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe> */}
                                <iframe style={{ maxWidth: "100%" }} title='Summer School Video' width="560" height="315" src="https://www.youtube.com/embed/qE8KGDy0Tx8" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </Col>
                        </Row>
                    </section>
                    <section id='about' className='main-container'>
                        <Row>
                            <div className='sub-heading'>
                                <h2>
                                    Summer School Scope & Goals
                            </h2>
                            </div>
                            <div>
                                <p>
                                    Norwegian University of Life Sciences, together with Belarusian State University and United Institute of Informatics Problems (National Academy of Sciences of Belarus), is organizing a summer school for Master and PhD students dedicated to analysis of biological data in infrared spectroscopy. Attendees will be introduced to the basics in molecular biology, machine learning and physics of infrared absorption, explained by renowned scientists in the corresponding fields. The main aim of summer school is to provide experience in solving a complex research problem in a multidisciplinary team. Students in biology, physics and computer science will work together on a two-day project culminating in a project defense and a presentation session for early-stage researchers to share their research findings with other participants.
                                </p>
                            </div>
                        </Row>
                        <Row>
                            <div className='sub-heading'>
                                <h2>
                                    Acknowledgement
                            </h2>
                            </div>
                            <div>
                                <p>
                                    This summer school has been supported by the SIU project <i>"Belanoda - Multidisciplinary graduate and post-graduate education in big data analysis for life sciences"</i> (project number CPEA-LT-2016/10126) funded by the Eurasia program, Norwegian Center for International Cooperation in education (SIU).
                                </p>
                            </div>
                        </Row>
                        {/* <Row>
                            <div className='sub-heading'>
                                <h2>
                                    Audience
                            </h2>
                            </div>
                            <div>
                                <p>
                                    Ullamco anim reprehenderit ad irure magna reprehenderit duis magna eu aute fugiat. Nostrud proident ullamco fugiat veniam mollit minim nulla aliqua. Pariatur velit Lorem ut non Lorem nostrud ullamco mollit ullamco nisi. Elit consequat consectetur nisi adipisicing eu.
                                </p>
                                <ul>
                                    <li>
                                        In nisi pariatur adipisicing incididunt dolor ex qui fugiat voluptate ipsum nostrud. Dolore et est cillum reprehenderit anim minim. Nisi veniam sunt aliquip non quis labore proident ut sint tempor exercitation. Officia non ea occaecat esse. Quis elit eu deserunt non adipisicing dolore incididunt exercitation. Ipsum commodo incididunt non amet deserunt occaecat quis et nisi consequat culpa incididunt nulla incididunt.
                                    </li>
                                    <li>
                                        Occaecat aute dolore laboris magna laboris in officia adipisicing officia. In mollit reprehenderit veniam veniam ullamco consequat. Labore ex ut esse tempor aliquip laboris esse reprehenderit esse reprehenderit ullamco duis mollit.
                                    </li>
                                </ul>
                            </div>
                        </Row> */}
                        <Row>
                            <div className='sub-heading'>
                                <h2>
                                    Participation prerequisites
                            </h2>
                            </div>
                            <div>
                                <p>
                                    Certain topics from molecular biology, machine learning and spectroscopy will be covered extensively during summer school. However, participants are expected to have a background in mathematics equivalent to a first-year university course and an intermediate-level English sufficient to participate and be successful in learning process. Solid reasoning, ability to grasp quickly interdisciplinary relations and experience with group work is highly appreciated.
                                </p>
                            </div>
                        </Row>
                        <Row>
                            <div className='sub-heading'>
                                <h2>
                                    What will you get?
                            </h2>
                            </div>
                            <div>
                                <ul>
                                    <li>
                                        Learn basics from unfamiliar fields (biology, physics, data science)
                                    </li>
                                    <li>
                                        Learn how to combine it all to analyse spectra of organic compounds
                                    </li>
                                    <li>
                                        Experience of working in an interdisciplinary and international group
                                    </li>
                                </ul>
                            </div>
                        </Row>
                        <Row>
                            <div className='sub-heading'>
                                <h2>
                                    Preliminary Dates
                            </h2>
                            </div>
                            <div>
                                <ol>
                                    <li>
                                        Early February: Applications open
                                    </li>
                                    <li>
                                        Late March: Applications close
                                    </li>
                                    <li>
                                        Early May: Acceptance notification
                                    </li>
                                    <li>
                                        August 11th – 17th 2019: Summer School
                                    </li>
                                </ol>
                            </div>
                        </Row>
                        <Row>
                            <div className='sub-heading'>
                                <h2>
                                    Useful information for those who are travelling abroad
                            </h2>
                            </div>
                            <div>
                                <p>The general information you may need before and during your stay in Belarus can be found <a href="General_Information.pdf" rel="noopener noreferrer" target='_blank'>here</a></p>
                                <p>You may also need <a href="Travel_information.pdf" rel="noopener noreferrer" target='_blank'>The Travel Guide</a></p>
                            </div>
                        </Row>
                    </section>


                    <section id='materials' className='main-container'>
                        <div className='heading'>
                            <h2>Materials</h2>
                        </div>
                        <Row>
                            <p>Videos (including pre-course lectures) are available online:</p>
                            <Button ghost href="https://www.youtube.com/watch?v=qE8KGDy0Tx8&list=PLsvFOj1U2b6r2X0hpzaNCVao3Wt8D0uQc" target="_blank">Videos</Button>
                        </Row>
                    </section>


                    <section id="program" className='main-container'>
                        <div className='heading'>
                            <h2>Preliminary Program</h2>
                        </div>
                        <img alt="program"
                            src="ProgramSIUsummerSchool_Minsk2019_20190807_cropped.png"
                            style={{ maxWidth: '100%' }}></img>
                        <p>Pdf version of the program can be found <a href="ProgramSIUsummerSchool_Minsk2019_20190807.pdf" rel="noopener noreferrer" target='_blank'>here</a></p>
                    </section>


                    <section id="venue" className="main-container">
                        <div className='heading'>
                            <h2>Venue</h2>
                        </div>
                        <p>The school will be held at the <a href='https://goo.gl/maps/4iBERvrfpWL2' rel="noopener noreferrer" target='_blank'>BSU International Relations Faculty</a>.</p>
                        <img src='venue_2019.png' alt='Map' style={{ maxWidth: '100%' }}></img>
                    </section>

                    <section id='contact' className='main-container'>
                        <div className="heading">
                            <h2>Contact</h2>
                        </div>
                        <Row>
                            <p>If you have any further questions about our summer school, feel free to send us an email to <a href='mailto:stanislau.trukhan@nmbu.no'>stanislau.trukhan@nmbu.no</a>.</p>
                        </Row>
                    </section>
                </Content>
                <Footer style={{ textAlign: 'center' }}>
                    BioSpec Group ©2019 Created by BioSpec
                </Footer>
            </Layout>
        );
    }
}

export default Main;
